import Config from 'config'

export default {
  isLogged (state) {
    return !!state.token
  },
  getCurrent (state) {
    return state.current
  },
  getUserType (state) {
    return state.userType
  },
  isManager (state) {
    return state.userType === 'manager'
  },
  hasAddresses (state) {
    return state.addresses && state.addresses.length > 0
  },
  getAddressSelected (state) {
    return state.addressSelected
  },
  getCurrentRole (state) {
    return state.role
  },
  getUserStore (state) {
    if (state.role && state.role.userStore) {
      return state.role.userStore
    } else {
      return null
    }
  },
  getUserPlainStore (state, getters) {
    // store come with IT-.....
    // get .... part
    if (getters.getUserStore) {
      let arr = getters.getUserStore.split('-')
      arr = arr[arr.length - 1]
      return arr
    } else {
      return ''
    }
  },
  getStoreId (state) {
    if (state && state.storeId) {
      return state.storeId
    } else {
      return null
    }
  },
  getUserStoreId (state) {
    if (state && state.userStoreId) {
      return state.userStoreId
    } else {
      return null
    }
  },
  getCurrentAgentID (state) {
    if (state.role && state.role.agent_id) {
      return state.role.agent_id
    } else {
      return null
    }
  },
  getOnlineStoreCode (state) {
    return state.onlineStoreCode
  },
  getCurrentStoreCode (state) {
    return state.storeCode
  },
  getOnlineMode (state, getters, rootState) {
    return state.isOnlineMode || (rootState.ui.urlCode === getters['getOnlineStoreCode'])
  },
  getCurrentAddress (state, getters, rootState) {
    if (state.current) {
      return `${state.current.address}, ${state.current.city}, ${state.current.region} – ${state.current.country}`
    } else if (getters.getOnlineMode) {
      return Config.Theme.onlineStore.label
    } else {
      return ''
    }
  },
  getCoupons (state) {
    return state.coupons
  }
}
